import commonRes from '../abstract.resource';
import {readServiceGroup} from '../serializers/servicegroup.serializer';

const mod = angular.module('app.common.resources.service-group', [commonRes])

.factory('ServiceGroupResource', function ($q, AbstractResource) {
  class ServiceGroupResource extends AbstractResource {
    constructor() {
      super('service-groups', ServiceGroupResource.fromBackend, true);
    }

    /**
     * Parse a service group retrieved from the backend.
     * @param {Object} o
     * @returns {ServiceGroup}
     */
    static fromBackend(o) {
      return readServiceGroup(o).makeImmutable();
    }
  }

  return new ServiceGroupResource();
});

export default mod.name;
